import React from 'react';
import { companyHistory } from '../../../data/team';

const History: React.FC = () => {
  return (
    <section className="py-16 bg-neutral">
      <div className="container-wide">
        <div className="section-title">
          <h2>Naša zgodovina</h2>
          <div className="divider"></div>
          <p>
            Spoznajte bogato zgodovino Oljarne Krajnc, ki že več kot 90 let ohranja
            tradicijo pridelave bučnega olja v Sloveniji.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-12">
          <HistoryCard
            title={companyHistory.founding.title}
            content={companyHistory.founding.content}
            year={companyHistory.founding.year}
            imagePath="/images/history-founding.jpg"
          />
          
          <HistoryCard
            title={companyHistory.growth.title}
            content={companyHistory.growth.content}
            year={companyHistory.growth.year}
            imagePath="/images/history-growth.jpg"
          />
          
          <HistoryCard
            title={companyHistory.modern.title}
            content={companyHistory.modern.content}
            year={companyHistory.modern.year}
            imagePath="/images/history-modern.jpg"
          />
        </div>
        
        <div className="mt-16 bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-primary-700 mb-4">
            Tradicionalni postopek pridelave
          </h3>
          
          <p className="mb-6 text-accent-700">
            V Oljarni Krajnc še vedno uporabljamo tradicionalni postopek pridelave bučnega olja, 
            ki ga je uvedel ustanovitelj Franc Krajnc. Naša edinstvena lastnost je predvsem ta, 
            da imamo še vedno tradicionalno, unikatno pridelavo. Bučno olje se pri nas prideluje 
            na identičen način, kot ga je davnega leta 1927 vpeljal dedek. To je način, ki se je 
            že takrat izkazal za uspešnega in še danes omogoča izdelavo najboljših izdelkov.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <ProcessStep
              number="01"
              title="Izbor bučnih semen"
              description="Skrbno izbiramo najboljša bučna semena od lokalnih pridelovalcev."
            />
            
            <ProcessStep
              number="02"
              title="Čiščenje in sušenje"
              description="Semena temeljito očistimo in posušimo do optimalne vlažnosti."
            />
            
            <ProcessStep
              number="03"
              title="Praženje in mletje"
              description="Semena pražimo pri natančno določeni temperaturi in jih zmeljemo."
            />
            
            <ProcessStep
              number="04"
              title="Stiskanje olja"
              description="S tradicionalno prešo iz mletih semen iztisnemo kakovostno olje."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Component for individual history card
const HistoryCard: React.FC<{
  title: string;
  content: string;
  year: string;
  imagePath: string;
}> = ({ title, content, year, imagePath }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 card-glow">
      <div className="relative h-48">
        <img 
          src={imagePath} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 right-0 bg-secondary text-white px-4 py-2">
          {year}
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-primary-700 mb-3">{title}</h3>
        <p className="text-accent-700">{content}</p>
      </div>
    </div>
  );
};

// Component for process step
const ProcessStep: React.FC<{
  number: string;
  title: string;
  description: string;
}> = ({ number, title, description }) => {
  return (
    <div className="flex">
      <div className="flex-shrink-0 mr-4">
        <div className="w-10 h-10 bg-primary-100 text-primary-700 rounded-full flex items-center justify-center font-bold">
          {number}
        </div>
      </div>
      <div>
        <h4 className="text-lg font-semibold text-primary-700 mb-1">{title}</h4>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </div>
  );
};

export default History;